<template>
  <div>
    <span class="is-hidden">{{ cellData ? 1 : 0 }}</span>
    <span v-if="cellData === true" class="cls cls-check-circle-1-filled has-text-success"></span>
  </div>
</template>

<script>
import { CellMixin } from '/@/modules/core/table/mixins/CellMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'BooleanCell',
  mixins: [CellMixin]
};
</script>
